<div class="header">
  <div class="container">
    <div class="row flmid">
      <div class="col-auto pl-0 flmid">
        <span  (click)="onlogoClick()" class="logo-brand" rel="noopener">
          <img class="brand headerImage"  alt="Logo" height="30"  />
        </span>
      </div>

      <div class="lang-dropdown col-auto ml-auto pr-0" *ngIf="isLanguageDropDown">
        <ng-select [items]="languages" bindLabel="value" bindValue="key" placeholder="Select Language"
            (change)="ChangeLanguage($event.key)" [(ngModel)]="currentLang" [clearable]="false"
            [searchable]="false">

            <ng-template ng-label-tmp let-item="item">
                <img height="15" width="20" [src]="getFlagImage(item.flagName)" alt="" />
                <strong class="lang">{{item.value}}</strong>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index">
                <img height="15" width="20" [src]="getFlagImage(item.flagName)" alt="" />
                <strong class="lang">{{item.value}}</strong>
            </ng-template>

        </ng-select>
    </div>
    </div>
  </div>
</div>